import { EuiLink } from "@elastic/eui";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  CopyButton,
  FileButton,
  Flex,
  Grid,
  Group,
  Image,
  LoadingOverlay,
  rem,
  ScrollArea,
  Table,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowBackUp,
  IconArrowForwardUp,
  IconCheck,
  IconEyeSearch,
  IconLibraryPhoto,
  IconPhotoShare,
  IconPhotoUp,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import cx from "clsx";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NotificationExtension } from "../../../../../_base/extension/NotificationExtension";
import { formatDateToString } from "../../../../../_base/helper/FunctionHelper";
import { uploadImageAddFolder } from "../../../../../api/ApiMore";
import { handleEditProductNew } from "../../../../../api/ApiProduct";
import TinyMCEEditor from "../../../../../common/Tinymce/TinyMCEEditor";
import OpenProductTab from "../../../../../components/ProductTabs";
import { TblItemImageCommand } from "../../../../../model/ProductList";
import { useProductCreateStore } from "../../../../../store/useProductCreateStore";
import classes from "../../../../../Styles/TableScrollArea.module.css";
import StockPhoto from "../StockPhoto";

const DescriptionItem = () => {
  const navigate = useNavigate();
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);
  const setDataItemBase = useProductCreateStore(
    (state) => state.setDataItemBase
  );
  const [isOpenUpdateTechnical, setIsOpenUpdateTechnical] = useState(false);
  const [modal, setModel] = useState("");
  const [
    visible,
    { toggle: toggleSkeleton, open: openSkeleton, close: closeSkeleton },
  ] = useDisclosure(false);
  const [
    visibleUploadImage,
    {
      toggle: toggleUploadImage,
      open: openUploadImage,
      close: closeUploadImage,
    },
  ] = useDisclosure(false);

  const [shortDescription, setShortDescription] = useState(
    dataItemBase?.description
  ); // Mô tả dài

  const [itemSummary, setItemSummary] = useState(dataItemBase?.itemSummary); //Mô tả đặc tính ngắn
  const [itemSpec, setItemSpec] = useState(dataItemBase?.itemSpec); //Thông số kỹ thuật
  const [promotionDescription, setPromotionDescription] = useState(
    dataItemBase?.attribute10
  ); // Mô tả khuyến mãi
  const [dataItemImage, setDataItemImage] = useState<any[]>([]);
  const [addImageToArticle, setAddImageToArticle] = useState<string>("");
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const resetRef = useRef<() => void>(null);
  const [scrolled, setScrolled] = useState(false);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;

  const modalsStockPhoto = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Kho ảnh có sẵn</Title>,
      size: "auto",
      zIndex: 1000,
      children: (
        <StockPhoto
          dataImage={dataItemImage}
          addImage={setDataItemImage}
          isDescriptionItem={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // const handleChangeValue = (value: any, label: string) => {
  //   setDataItemBase({
  //     ...dataItemBase,
  //     [label]: value,
  //   });
  // };

  // console.log("shortDescription", shortDescription);
  // console.log("itemSummary", itemSummary);
  // console.log("itemSpec", itemSpec);
  // console.log("dataItemBase", dataItemBase);

  const handleSubmitForm = async () => {
    const dataSubmit = {
      ...dataItemBase,
      itemSummary: itemSummary,
      description: shortDescription,
      itemSpec: itemSpec,
      attribute10: promotionDescription,
      attribute5: JSON.stringify(dataItemImage),
    };

    setDataItemBase({
      ...dataItemBase,
      itemSummary: itemSummary,
      description: shortDescription,
      itemSpec: itemSpec,
      attribute10: promotionDescription,
      attribute5: JSON.stringify(dataItemImage),
    });

    if (!itemSummary || String(itemSummary).trim().length === 0) {
      NotificationExtension.Fails("Vui lòng nhập thông số ngắn !");
      return;
    }
    //  else if (
    //   !shortDescription ||
    //   String(shortDescription).trim().length === 0
    // ) {
    //   NotificationExtension.Fails(
    //     "Vui lòng nhập bài viết giới thiệu sản phẩm ! "
    //   );
    // }
    else {
      try {
        openSkeleton();
        const response = await handleEditProductNew(dataSubmit);
        if (response && response.success) {
          NotificationExtension.Success("Cập nhật dữ liệu thành công");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        closeSkeleton();
      }
    }
  };
  const onNavigateOnWeb = () => {
    window.open(`${hacomUrl}/${dataItemBase?.url}`, "_blank");
  };

  const handleUploadImage = async (files: File[] | File) => {
    const newDate = formatDateToString(new Date());
    const fileArray = Array.isArray(files) ? files : [files];

    if (!files || fileArray.length === 0) {
      NotificationExtension.Fails("Bạn chưa chọn file tải lên !");
      return;
    } else {
      openUploadImage();
      try {
        const res = await uploadImageAddFolder(
          `cdn/Media/Image/DescribeProduct/${newDate}`,
          fileArray
        );

        if (res && res.success) {
          const data = res?.data;
          setDataItemImage([
            ...dataItemImage,
            ...data.map((item: any) => ({
              image: item.url,
              imageName: item.pathNameBefore,
            })),
          ]);
          NotificationExtension.Success("Tải ảnh lên thành công !");
        } else {
          NotificationExtension.Fails(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        closeUploadImage();
      }
    }
  };

  useEffect(() => {
    if (
      dataItemBase?.attribute5 &&
      String(dataItemBase?.attribute5).length > 0
    ) {
      setDataItemImage(JSON.parse(dataItemBase?.attribute5));
    }
  }, [dataItemBase?.attribute5]);

  useEffect(() => {
    if (dataItemImage.length > 10) {
      setDataItemImage(dataItemImage.slice(1));
    }
  }, [dataItemImage]);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        mx="10px"
        style={{ position: "relative" }}
        mt={10}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Flex justify={"space-between"} align={"center"}>
          <CopyButton value={String(dataItemBase?.itemName)} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip
                label={copied ? "Đã sao chép" : "Sao chép"}
                withArrow
                position="right"
              >
                <Badge
                  color={copied ? "teal" : "blue"}
                  onClick={copy}
                  style={{ cursor: "pointer" }}
                  size="lg"
                >
                  {dataItemBase?.itemName}
                </Badge>
              </Tooltip>
            )}
          </CopyButton>
        </Flex>

        <Flex direction={"column"} gap="xs">
          <Text fw={600} size="20px" mt={25}>
            {/* Tóm tắt đặc tính chính */}
            Thông số ngắn<span style={{ color: "red" }}>*</span>
          </Text>

          <TinyMCEEditor
            height="400"
            contentText={dataItemBase?.itemSummary || ""}
            nameOnchange="itemSummary"
            setValue={setItemSummary}
          />
        </Flex>

        <Flex direction={"column"} gap="xs">
          <Text fw={600} size="20px" mt={25}>
            {/* Mô tả chi tiết */}
            Bài viết giới thiệu sản phẩm
            {/* <span style={{ color: "red" }}>*</span> */}
          </Text>
          <Grid>
            {isOpen ? (
              <Grid.Col span={{ base: 12, md: 3 }} pos="relative">
                <LoadingOverlay
                  visible={visibleUploadImage}
                  zIndex={1000}
                  overlayProps={{ radius: "sm", blur: 2 }}
                />
                <Grid>
                  <Grid.Col span={{ base: 12, md: 12, lg: 4.5 }}>
                    <FileButton
                      resetRef={resetRef}
                      accept="image/png,image/jpeg"
                      multiple
                      onChange={(file) => {
                        if (file && file.length > 0) {
                          handleUploadImage(file);
                        } else {
                          NotificationExtension.Fails(
                            "Bạn chưa chọn file tải lên !"
                          );
                        }
                        resetRef.current?.();
                      }}
                    >
                      {(props) => (
                        <Button
                          w={"100%"}
                          leftSection={
                            <IconPhotoUp
                              style={{ width: rem(14), height: rem(14) }}
                            />
                          }
                          {...props}
                        >
                          Tải ảnh lên
                        </Button>
                      )}
                    </FileButton>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 12, lg: 4.5 }}>
                    <Button
                      leftSection={<IconLibraryPhoto size={16} />}
                      w={"100%"}
                      onClick={() => modalsStockPhoto()}
                    >
                      Kho ảnh có sẵn
                    </Button>
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 12, lg: 3 }}>
                    <Button
                      leftSection={<IconArrowBackUp size={16} />}
                      w={"100%"}
                      color="red"
                      onClick={() => setIsOpen(false)}
                    >
                      Đóng
                    </Button>
                  </Grid.Col>
                </Grid>

                <ScrollArea
                  h={850}
                  onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                  offsetScrollbars
                  mt={5}
                >
                  <Table highlightOnHover striped withColumnBorders>
                    <Table.Thead
                      className={cx(classes.header, {
                        [classes.scrolled]: scrolled,
                      })}
                    >
                      <Table.Tr>
                        <Table.Th ta={"center"} colSpan={2}>
                          <Flex justify={"center"} gap={"5px"}>
                            <Text fw={"bold"}>Ảnh tải lên</Text>
                            <Text fw={"bold"} c={"red"}>
                              (Mỗi lần thao tác tối đa 10 ảnh)
                            </Text>
                          </Flex>
                        </Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {dataItemImage && dataItemImage.length > 0 ? (
                        (() => {
                          const chunks = [];
                          for (let i = 0; i < dataItemImage.length; i += 2) {
                            chunks.push(dataItemImage.slice(i, i + 2));
                          }
                          return chunks;
                        })().map((chunk, chunkIndex) => (
                          <Table.Tr key={chunkIndex}>
                            {chunk.map((item, indexInChunk) => (
                              <Table.Td
                                key={`${chunkIndex}-${indexInChunk}`}
                                w={"50%"}
                              >
                                <Flex w={"100%"} justify={"center"}>
                                  <Image
                                    h="auto"
                                    w={"100%"}
                                    radius={"sm"}
                                    src={item.image}
                                  />
                                </Flex>
                                <Flex
                                  w={"100%"}
                                  justify="center"
                                  gap={"xs"}
                                  mt={5}
                                >
                                  <Button
                                    leftSection={<IconPhotoShare />}
                                    size="xs"
                                    onClick={() => {
                                      setAddImageToArticle(item.image);
                                      setTimeout(() => {
                                        setAddImageToArticle("");
                                      }, 100);
                                    }}
                                  >
                                    Chọn
                                  </Button>
                                  <Button
                                    leftSection={<IconTrash />}
                                    size="xs"
                                    color="red"
                                    onClick={() => {
                                      const dataDelete = dataItemImage.filter(
                                        (i) => i.image !== item.image
                                      );

                                      setDataItemImage(dataDelete);
                                    }}
                                  >
                                    Xóa
                                  </Button>
                                </Flex>
                              </Table.Td>
                            ))}
                            {chunk.length === 1 && <Table.Td></Table.Td>}
                          </Table.Tr>
                        ))
                      ) : (
                        <Table.Tr>
                          <Table.Td colSpan={2} ta={"center"} h={775}>
                            <Flex
                              justify={"center"}
                              align={"center"}
                              h={"100%"}
                            >
                              <Text>Bạn chưa tải lên ảnh nào !</Text>
                            </Flex>
                          </Table.Td>
                        </Table.Tr>
                      )}
                    </Table.Tbody>
                  </Table>
                </ScrollArea>
              </Grid.Col>
            ) : (
              <Grid.Col span={0.3}>
                <ActionIcon
                  variant="light"
                  color="blue"
                  w={"100%"}
                  h={"100%"}
                  onClick={() => setIsOpen(true)}
                >
                  <IconArrowForwardUp />
                </ActionIcon>
              </Grid.Col>
            )}
            <Grid.Col span={{ base: 12, md: isOpen ? 9 : 11.7 }}>
              <TinyMCEEditor
                height="800"
                contentText={dataItemBase?.description || ""}
                nameOnchange="description"
                setValue={setShortDescription}
                addImageToArticle={addImageToArticle}
              />
            </Grid.Col>
          </Grid>
        </Flex>

        <Flex direction={"column"} gap="xs">
          <Text fw={600} size="20px" mt={25}>
            {/* Mô tả chi tiết */}
            Khuyến mãi (web)
          </Text>

          <TinyMCEEditor
            height="400"
            contentText={dataItemBase?.attribute10 || ""}
            nameOnchange="promotionDescription"
            setValue={setPromotionDescription}
          />
        </Flex>

        <Box>
          <EuiLink
            onClick={() => setIsOpenUpdateTechnical(!isOpenUpdateTechnical)}
            style={{
              fontSize: "22px",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            Cập nhật bảng thông số sản phẩm
          </EuiLink>
          <Box>
            {isOpenUpdateTechnical && (
              <>
                {/* <QuillEditor
                description={dataItemBase?.itemSpec || ""}
                toolbarId="t1"
                setValue={setModel}
                onChangeValue={(html: string) =>
                  handleChangeValue(html, "itemSpec")
                }
              /> */}
                <TinyMCEEditor
                  contentText={dataItemBase?.itemSpec || ""}
                  nameOnchange="itemSpec"
                  setValue={setItemSpec}
                />
              </>
            )}
          </Box>
        </Box>
        <Group
          justify="flex-end"
          mt="lg"
          p="10px 0"
          bg={"rgba(255, 255, 255, 0)"}
          style={{
            position: "sticky",
            bottom: 10,
            margin: "0px 75px",
            zIndex: "999",
          }}
        >
          <Button
            type="button"
            color="#3598dc"
            variant="filled"
            leftSection={<IconEyeSearch size={18} />}
            onClick={() => onNavigateOnWeb()}
          >
            Xem trên web
          </Button>
          <OpenProductTab
            productId={dataItemBase?.id}
            itemCode={dataItemBase?.itemName ?? ""}
            tabToOpen="info6"
            buttonText="Mở trang tab"
            variant="filled"
          />
          <Button
            type="button"
            color="#3598dc"
            onClick={(e) => {
              handleSubmitForm();
            }}
            leftSection={<IconCheck size={18} />}
            variant="filled"
          >
            Lưu
          </Button>
          <Button
            color="red"
            onClick={() => {
              navigate(-1);
            }}
            leftSection={<IconX size={18} />}
            variant="filled"
          >
            Đóng
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default DescriptionItem;
